import { Button, FIBin, FITag, FIUser, FIX, Icon, Portal, Text, View, useDialog } from '@fold-dev/core'
import React from 'react'
import { dispatchTodoEvent } from '../todo'
import { UserButton } from './user-button'
import { LabelButton } from './label-button'

export const FloatingToolbar = ({
    selection,
    onDelete,
    onCancel,
    onUserUpdate,
    onLabelUpdate,
    onUserFilter,
    onLabelFilter,
}) => {
    return (
        <View
            row
            position="fixed"
            bgToken="surface-strong"
            colorToken="text-on-color"
            p="var(--f-space-inset-x-4)"
            radius="var(--f-radius)"
            shadow="var(--f-shadow-xl)"
            border="1px solid var(--f-color-border)"
            zIndex={1000}
            className="f-fadein"
            display={!Object.keys(selection).length ? 'none' : 'flex'}
            style={
                {
                    'bottom': 20,
                    'left': '50%',
                    'transform': 'translateX(-50%)',
                    '--f-button-color': 'var(--f-color-text-weaker)',
                    '--f-button-color-hover': 'var(--f-color-accent)',
                    '--f-button-background-color-hover': 'var(--f-color-surface)',
                } as any
            }>
            <Button
                size="sm"
                onClick={onCancel}
                subtle>
                <Icon
                    icon={FIX}
                    className="f-buttonize"
                />
            </Button>
            <Text
                fontWeight={500}
                m="0 2rem 0 0.5rem">
                {Object.keys(selection).length} selected
            </Text>
            <Button
                size="sm"
                subtle
                onClick={onDelete}>
                <Icon
                    icon={FIBin}
                    className="f-buttonize"
                />
            </Button>
            {/* 
            <UserButton
                disabled={!teamId && !projectId}
                portal={Portal}
                users={users}
                onAdd={onUserAdd}
                onDelete={onUserDelete}
                userSelectProps={{ context: { teamId, projectId } }}
            />

            <LabelButton
                portal={Portal}
                labels={labels}
                onAdd={onLabelAdd}
                onDelete={onLabelDelete}
            />

            <Button 
                size="sm"
                subtle>
                <Icon
                    icon={FIUser}
                    className="f-buttonize"
                    onClick={onDelete}
                />
            </Button>
            <Button 
                size="sm"
                subtle>
                <Icon
                    icon={FITag}
                    className="f-buttonize"
                    onClick={onDelete}
                />
            </Button> */}
        </View>
    )
}
